<template>
  <InboxErrorNotice
    :notice="notice"
    :message="errorMessage"
    :title="notice.error.origin.account"
    @archived="$emit('archived', $event)"
  />
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue";

import InboxErrorNotice from "@/components/inbox/InboxErrorNotice.vue";
import type { GoogleErrorNotice } from "@/components/inbox/notice";

export default defineComponent({
  name: "InboxGoogleErrorNotice",
  components: { InboxErrorNotice },
  props: {
    notice: {
      type: Object as PropType<GoogleErrorNotice>,
      required: true,
    },
  },
  emits: {
    archived: (_noticeId: string) => true,
  },
  setup(props) {
    const errorMessage = computed(() => {
      const source = {
        connections: "contacts",
        directory: "directory contacts",
        other: "other contacts",
        self: "profile",
      }[props.notice.error.origin.peopleSource];
      return `Couldn't fetch Google ${source}: ${props.notice.error.error}`;
    });

    return { errorMessage };
  },
});
</script>
